import adrian from '~/assets/images/parents/man/Adrian.png';
import alex from '~/assets/images/parents/man/Alex.png';
import andrew from '~/assets/images/parents/man/Andrew.png';
import angel from '~/assets/images/parents/man/Angel.png';
import anthony from '~/assets/images/parents/man/Anthony.png';
import benjamin from '~/assets/images/parents/man/Benjamin.png';
import claude from '~/assets/images/parents/man/Claude.png';
import daniel from '~/assets/images/parents/man/Daniel.png';
import diego from '~/assets/images/parents/man/Diego.png';
import ethan from '~/assets/images/parents/man/Ethan.png';
import evan from '~/assets/images/parents/man/Evan.png';
import gabriel from '~/assets/images/parents/man/Gabriel.png';
import isaac from '~/assets/images/parents/man/Isaac.png';
import john from '~/assets/images/parents/man/John.png';
import joshua from '~/assets/images/parents/man/Joshua.png';
import juan from '~/assets/images/parents/man/Juan.png';
import kevin from '~/assets/images/parents/man/Kevin.png';
import louis from '~/assets/images/parents/man/Louis.png';
import michael from '~/assets/images/parents/man/Michael.png';
import niko from '~/assets/images/parents/man/Niko.png';
import noah from '~/assets/images/parents/man/Noah.png';
import samuel from '~/assets/images/parents/man/Samuel.png';
import santiago from '~/assets/images/parents/man/Santiago.png';
import vincent from '~/assets/images/parents/man/Vincent.png';
import amelia from '~/assets/images/parents/woman/Amelia.png';
import ashley from '~/assets/images/parents/woman/Ashley.png';
import audrey from '~/assets/images/parents/woman/Audrey.png';
import ava from '~/assets/images/parents/woman/Ava.png';
import briana from '~/assets/images/parents/woman/Briana.png';
import camila from '~/assets/images/parents/woman/Camila.png';
import charlotte from '~/assets/images/parents/woman/Charlotte.png';
import elizabeth from '~/assets/images/parents/woman/Elizabeth.png';
import emma from '~/assets/images/parents/woman/Emma.png';
import evelyn from '~/assets/images/parents/woman/Evelyn.png';
import giselle from '~/assets/images/parents/woman/Giselle.png';
import grace from '~/assets/images/parents/woman/Grace.png';
import hannah from '~/assets/images/parents/woman/Hannah.png';
import isabella from '~/assets/images/parents/woman/Isabella.png';
import jasmine from '~/assets/images/parents/woman/Jasmine.png';
import misty from '~/assets/images/parents/woman/Misty.png';
import natalie from '~/assets/images/parents/woman/Natalie.png';
import nicole from '~/assets/images/parents/woman/Nicole.png';
import olivia from '~/assets/images/parents/woman/Olivia.png';
import sophia from '~/assets/images/parents/woman/Sophia.png';
import violet from '~/assets/images/parents/woman/Violet.png';
import zoe from '~/assets/images/parents/woman/Zoe.png';

export const parentsImages = [
	benjamin,
	daniel,
	joshua,
	noah,
	andrew,
	juan,
	alex,
	isaac,
	evan,
	ethan,
	vincent,
	angel,
	diego,
	adrian,
	gabriel,
	michael,
	santiago,
	kevin,
	louis,
	samuel,
	anthony,
	hannah,
	audrey,
	jasmine,
	giselle,
	amelia,
	isabella,
	zoe,
	ava,
	camila,
	violet,
	sophia,
	evelyn,
	nicole,
	ashley,
	grace,
	briana,
	natalie,
	olivia,
	elizabeth,
	charlotte,
	emma,
	john,
	niko,
	claude,
	misty,
];
